import { useState } from "react";
import styles from "./quick-access.module.css";

export default function QuickAccess() {
  const [activeMenu, setActiveMenu] = useState("");
  const handleScroll = (id) => {
    var element = document.getElementById(id);
    var headerOffset = 40;
    if (window.scrollY > element.offsetTop) {
      headerOffset = 150;
    }
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  return (
    <div className={`${styles.quickAccessWrapper} hidden-xs`}>
      <div
        onClick={() => handleScroll("slider")}
        className={activeMenu === "slider" ? styles.activeMenu : null}
      >
        <span>خانه</span>
        <span>
          <i className="fa fa-home" />
        </span>
      </div>
      <div
        onClick={() => handleScroll("about")}
        className={activeMenu === "about" ? styles.activeMenu : null}
      >
        <span>درباره شرکت</span>
        <span>
          <i className="fa fa-building" />
        </span>
      </div>
      <div
        onClick={() => handleScroll("product")}
        className={activeMenu === "product" ? styles.activeMenu : null}
      >
        <span>محصولات</span>
        <span>
          <i className="fa fa-cubes" />
        </span>
      </div>
      <div
        onClick={() => handleScroll("news")}
        className={activeMenu === "news" ? styles.activeMenu : null}
      >
        <span>اخبار</span>
        <span>
          <i className="fa fa-rss" />
        </span>
      </div>
      <div
        onClick={() => handleScroll("attachment-home")}
        className={activeMenu === "attachment-home" ? styles.activeMenu : null}
      >
        <span>چند رسانه ای</span>
        <span>
          <i className="fa fa-images" />
        </span>
      </div>
      <div
        onClick={() => handleScroll("footer")}
        className={activeMenu === "footer" ? styles.activeMenu : null}
      >
        <span>اطلاعات تماس</span>
        <span>
          <i className="fa fa-location" />
        </span>
      </div>
    </div>
  );
}
